import assignee from "../../assets/images/assignee.png";
import { useEffect, useState, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import {
  ProjectList,
  AssigneesList,
  useProjectList,
  useProjectReportList,
  useAssigneesList,
  useProjectReportListTotal,
  useReportList,
  useReportListTotal,
  ReportListTotal,
  EmployeeList,
  useTeamsList,
  useEmployeeList,
  useLeaveReportList,
  useLeaveReportListTotal,
  useFullLeaveReportList,
  useEmployeeLeaveTrackerReportList,
  EmployeeLeaveTrackerReportList,
} from "./api";
import { Calendar } from "primereact/calendar";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { convertJSONtoCSV, dateBeautify } from "../../helpers/utils";
import DataLoading from "../../components/DataLoading";
import DataEmpty from "../../components/DataEmpty";
import { RadioButton } from "primereact/radiobutton";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import randomColor from "randomcolor";
import { Toast } from "primereact/toast";
import TooltipHover from "../../components/TooltipHover";
import DefaultImage from "../../profile_images/DefaultImage";
import DownloadButton from "../../components/DownloadButton";
import { TeamsList } from "./api";
import Papa from "papaparse";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// const initialReportData: any = [];

// const [reportData, setReportData] = useState(initialReportData)

type ProjectType = {
  _id: string;
  name: string;
  projectTotalHours: number;
};

type AssigneeType = {
  _id: string;
  name: string;
  profilepic: string;
  assigneesTotal: number;
  tasks?: string[];
};

type DateType = {
  _id: string;
  date: string;
  tasks?: string[];
  dateTotal: number;
};

type TaskType = {
  taskId: string;
  taskName: string;
  totalhours: number;
  subTaskId: string;
  subTaskName: string;
  _id: string;
  comments?: string;
};

type SubTaskType = {
  subTaskId: string;
  subTaskName: string;
};

const transformTask = ({
  taskId,
  taskName,
  _id,
  totalhours,
  comments,
}: {
  taskId: string;
  taskName: string;
  _id: string;
  totalhours: number;
  comments: string;
}) => {
  return {
    _id,
    taskId,
    taskName,
    totalhours,
    comments,
  };
};

const transformPADReportData = ({
  _id,
  projectName,
  assigneesList,
  projectTotal,
}: {
  _id: string;
  projectName: string;
  assigneesList: string[];
  projectTotal: number;
}) => {
  let tasks: string[] = [];

  const transformAssigness = ({
    name,
    _id,
    profilepic,
    assigneesTotal,
    dateList,
  }: {
    name: string;
    _id: string;
    profilepic: string;
    assigneesTotal: number;
    dateList: any;
  }) => {
    return {
      _id,
      name,
      profilepic,
      assigneesTotal,
      boxSize: dateList.reduce((preValue: any, date: any) => {
        return preValue + date.tasks.length;
      }, 0),
    };
  };

  const transformDate = ({
    _id,
    tasks,
    dateTotal,
  }: {
    _id: string;
    tasks: string[];
    dateTotal: number;
  }) => {
    return {
      date: _id,
      boxSize: tasks.length,
      dateTotal,
    };
  };

  return {
    projects: { name: projectName, _id: _id, projectTotalHours: projectTotal },

    assignees: assigneesList.map((assignee: any) =>
      transformAssigness(assignee)
    ),

    dates: assigneesList.reduce(
      (assigneesArr: AssigneeType[], assignee: any) => {
        const dates = assignee.dateList.map((date: any) => {
          tasks = tasks.concat(date.tasks);
          return transformDate(date);
        });
        return [...assigneesArr, ...dates];
      },
      []
    ),

    tasks: tasks.map((date: any) => transformTask(date)),
  };
};

const transformPDAReportData = ({
  _id,
  projectName,
  dateList,
  projectTotal,
}: {
  _id: string;
  projectName: string;
  dateList: string[];
  projectTotal: number;
}) => {
  let tasks: string[] = [];

  const transformAssigness = ({
    name,
    _id,
    profilepic,
    tasks,
    assigneesTotal,
  }: {
    name: string;
    _id: string;
    profilepic: string;
    tasks: string[];
    assigneesTotal: number;
  }) => {
    return {
      _id,
      name,
      profilepic,
      assigneesTotal,
      boxSize: tasks.length,
    };
  };

  const transformDate = ({
    _id,
    dateTotal,
    assigneesList,
  }: {
    _id: string;
    dateTotal: number;
    assigneesList: any;
  }) => {
    return {
      date: _id,
      dateTotal,
      boxSize: assigneesList.reduce((preValue: any, date: any) => {
        return preValue + date.tasks.length;
      }, 0),
    };
  };

  return {
    projects: { name: projectName, _id: _id, projectTotalHours: projectTotal },

    dates: dateList.map((date: any) => transformDate(date)),

    assignees: dateList.reduce((dateArr: DateType[], date: any) => {
      const assignees = date.assigneesList.map((assignee: any) => {
        tasks = tasks.concat(assignee.tasks);
        return transformAssigness(assignee);
      });
      return [...dateArr, ...assignees];
    }, []),
    tasks: tasks.map((date: any) => transformTask(date)),
  };
};

const transformAPDReportData = ({
  _id,
  profilepic,
  name,
  projectList,
  assigneesTotal,
}: {
  _id: string;
  profilepic: string;
  name: string;
  projectList: string[];
  assigneesTotal: number;
}) => {
  let tasks: string[] = [];

  const transformProject = ({
    _id,
    projectName,
    projectTotal,
    dateList,
  }: {
    projectName: string;
    _id: string;
    projectTotal: number;
    dateList: any;
  }) => {
    return {
      _id,
      name: projectName,
      projectTotalHours: projectTotal,
      boxSize: dateList.reduce((preValue: any, date: any) => {
        return preValue + date.tasks.length;
      }, 0),
    };
  };

  const transformDate = ({
    _id,
    tasks,
    dateTotal,
  }: {
    _id: string;
    tasks: string[];
    dateTotal: number;
  }) => {
    return {
      date: _id,
      boxSize: tasks.length,
      dateTotal,
    };
  };

  return {
    assignees: {
      name: name,
      profilepic: profilepic,
      _id: _id,
      assigneesTotal: assigneesTotal,
    },

    projects: projectList.map((date: any) => transformProject(date)),

    dates: projectList.reduce((projectArr: ProjectType[], project: any) => {
      const dates = project.dateList.map((date: any) => {
        tasks = tasks.concat(date.tasks);
        return transformDate(date);
      });
      return [...projectArr, ...dates];
    }, []),

    tasks: tasks.map((date: any) => transformTask(date)),
  };
};

const transformADPReportData = ({
  _id,
  profilepic,
  name,
  dateList,
  assigneesTotal,
}: {
  _id: string;
  profilepic: string;
  name: string;
  dateList: string[];
  assigneesTotal: number;
}) => {
  let tasks: string[] = [];

  const transformProject = ({
    _id,
    projectName,
    tasks,
    projectTotal,
  }: {
    tasks: string[];
    projectName: string;
    _id: string;
    projectTotal: number;
  }) => {
    return {
      _id,
      name: projectName,
      projectTotalHours: projectTotal,
      boxSize: tasks.length,
    };
  };

  const transformDate = ({
    _id,
    dateTotal,
    projectList,
  }: {
    _id: string;
    dateTotal: number;
    projectList: any;
  }) => {
    return {
      date: _id,
      dateTotal,
      boxSize: projectList.reduce((preValue: any, date: any) => {
        return preValue + date.tasks.length;
      }, 0),
    };
  };

  return {
    assignees: {
      name: name,
      profilepic: profilepic,
      _id: _id,
      assigneesTotal: assigneesTotal,
    },

    dates: dateList.map((date: any) => transformDate(date)),

    projects: dateList.reduce((dateArr: DateType[], date: any) => {
      const projects = date.projectList.map((project: any) => {
        tasks = tasks.concat(project.tasks);
        return transformProject(project);
      });
      return [...dateArr, ...projects];
    }, []),

    tasks: tasks.map((date: any) => transformTask(date)),
  };
};

const transformDPAReportData = ({
  _id,
  projectList,
  dateTotal,
}: {
  _id: string;
  projectList: string[];
  dateTotal: number;
}) => {
  let tasks: string[] = [];
  const transformProject = ({
    _id,
    projectName,
    projectTotal,
    assigneesList,
  }: {
    tasks: string[];
    projectName: string;
    _id: string;
    projectTotal: number;
    assigneesList: any;
  }) => {
    return {
      _id,
      name: projectName,
      projectTotalHours: projectTotal,
      boxSize: assigneesList.reduce((preValue: any, date: any) => {
        return preValue + date.tasks.length;
      }, 0),
    };
  };

  const transformAssigness = ({
    name,
    _id,
    profilepic,
    tasks,
    assigneesTotal,
  }: {
    name: string;
    _id: string;
    profilepic: string;
    assigneesTotal: number;
    tasks: string[];
  }) => {
    return {
      _id,
      name,
      profilepic,
      assigneesTotal,
      boxSize: tasks.length,
    };
  };

  return {
    dates: { date: _id, dateTotal: dateTotal },

    projects: projectList.map((assignee: any) => transformProject(assignee)),

    assignees: projectList.reduce(
      (projectArr: ProjectType[], assignee: any) => {
        const projects = assignee.assigneesList.map((project: any) => {
          tasks = tasks.concat(project.tasks);
          return transformAssigness(project);
        });
        return [...projectArr, ...projects];
      },
      []
    ),

    tasks: tasks.map((date: any) => transformTask(date)),
  };
};

const transformDAPReportData = ({
  _id,
  assigneesList,
  dateTotal,
}: {
  _id: string;
  assigneesList: string[];
  dateTotal: number;
}) => {
  let tasks: string[] = [];

  const transformProject = ({
    _id,
    projectName,
    tasks,
    projectTotal,
  }: {
    tasks: string[];
    projectName: string;
    _id: string;
    projectTotal: number;
  }) => {
    return {
      _id,
      name: projectName,
      projectTotalHours: projectTotal,
      boxSize: tasks.length,
    };
  };

  const transformAssigness = ({
    name,
    _id,
    profilepic,
    assigneesTotal,
    projectList,
  }: {
    name: string;
    _id: string;
    profilepic: string;
    assigneesTotal: number;
    projectList: any;
  }) => {
    return {
      _id,
      name,
      profilepic,
      assigneesTotal,
      boxSize: projectList.reduce((preValue: any, date: any) => {
        return preValue + date.tasks.length;
      }, 0),
    };
  };

  return {
    dates: { date: _id, dateTotal: dateTotal },

    assignees: assigneesList.map((assignee: any) =>
      transformAssigness(assignee)
    ),

    projects: assigneesList.reduce(
      (assigneeArr: AssigneeType[], assignee: any) => {
        const projects = assignee.projectList.map((project: any) => {
          tasks = tasks.concat(project.tasks);
          return transformProject(project);
        });
        return [...assigneeArr, ...projects];
      },
      []
    ),

    tasks: tasks.map((date: any) => transformTask(date)),
  };
};

const boxSizeCalc = (boxSize: number) => 40 + (boxSize - 1) * 45;

const ProjectTile = ({
  _id,
  name,
  projectTotalHours,
  boxSize,
}: {
  _id: string;
  name: string;
  projectTotalHours: number;
  boxSize: number;
}) => {
  const size = boxSizeCalc(boxSize);

  return (
    <div className="list-card-ui" style={{ height: size }} key={_id}>
      <div className="d-flex flex-align-center icon-title-sm">
        <img
          src="../assets/image/fiber_manual_record.svg"
          alt=""
          className="img-fluid"
        />
        <span className="single-line-ellipsis"> {name} </span>
      </div>
      <div className="rpt-time-hours">
        <span className="material-icons-outlined"> timer </span>
        <span className=" hours-text"> {projectTotalHours}h </span>
      </div>
    </div>
  );
};

const AssigneeTile = ({
  _id,
  name,
  profilepic,
  boxSize,
  assigneesTotal,
}: {
  _id: string;
  name: string;
  profilepic: string;
  boxSize: number;
  assigneesTotal: number;
}) => {
  const size = boxSizeCalc(boxSize);

  return (
    <div className="list-card-ui" style={{ height: size }} key={_id}>
      <div className="user-img-details-last-updated d-flex">
        <div className="user-image-block-sm">
          <img
            src={profilepic || assignee}
            alt="assig-5"
            className="img-fluid"
          />
        </div>
        <div className="user-name-last-update">{name}</div>
      </div>
      <div className="rpt-time-hours">
        <span className="material-icons-outlined"> timer </span>
        <span className=" hours-text"> {assigneesTotal}h </span>
      </div>
    </div>
  );
};

const DateTile = ({
  _id,
  date,
  boxSize,
  dateTotal,
}: {
  _id: string;
  date: string;
  boxSize: number;
  dateTotal: number;
}) => {
  const size = boxSizeCalc(boxSize);

  return (
    <div className="list-card-ui" style={{ height: size }} key={_id}>
      <div className="mt-minus-2">{date}</div>
      <div className="rpt-time-hours">
        <span className="material-icons-outlined"> timer </span>
        <span className=" hours-text"> {dateTotal}h </span>
      </div>
    </div>
  );
};

const TaskTile = ({
  _id,
  taskId,
  taskName,
  totalhours,
  subTaskId,
  subTaskName,
  comments,
}: {
  _id: string;
  taskId: string;
  taskName: string;
  totalhours: number;
  subTaskId: string;
  subTaskName: string;
  comments: string;
}) => {
  return (
    <div className="list-card-ui" key={_id}>
      <div className="d-flex">
        <div className="d-flex tsk-icon tsk-sub tst-cmplt">
          <span className="material-icons-round">subdirectory_arrow_right</span>
        </div>
        <div className="d-flex tsk-id">
          <p>{taskId}</p>
        </div>
        <div className="d-flex tsk-nm" style={{ cursor: "pointer" }}>
          <TooltipHover taskName={taskName} comments={comments} />
        </div>
      </div>

      <div className="d-flex rpt-hrs-wid">
        <div className="rpt-time-hours">
          <span className="material-icons-outlined"> timer </span>
          <span className="hours-text"> {totalhours}h </span>
        </div>
      </div>
    </div>
  );
};

const ReportSidePanel = ({
  reportType,
  myToast,
  setReportType,
  projectList,
  assigneesList,
  teamList,
  employeeList,
  selectedProject,
  selectedAssignee,
  selectedTeam,
  selectedEmployee,
  selectedDates,
  setSelectedProject,
  setSelectAssignee,
  setSelectDates,
  setShow,
  setSelectedGroup,
  selectedGroup,
  groupOptions,
  selectedRange,
  setSelectRange,
  selectProject,
  setSelectProject,
  setSelectEmployee,
  setSelectTeam,
  setProjectsShow,
  setTeamId,
  setGenerateReport,
  setLeaveShow,
  selectViewOptions,
  setSelectViewOptions,
  selectOption,
  setSelectOption,
}: {
  projectList: ProjectList[];
  assigneesList: AssigneesList[];
  teamList: TeamsList[];
  employeeList: EmployeeList[];
  reportType: string;
  setReportType: React.Dispatch<React.SetStateAction<string>>;
  selectedProject: string[] | undefined;
  selectedAssignee: string[] | undefined;
  selectedTeam: string | undefined;
  selectedEmployee: string | undefined;
  selectedDates: Date | Date[] | undefined;
  setSelectedProject: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
  setSelectAssignee: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  setSelectTeam: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectEmployee: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setLeaveShow: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedGroup: React.Dispatch<React.SetStateAction<optionItems>>;
  selectedGroup: optionItems;
  groupOptions: optionItems;
  selectedRange: string | undefined;
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>;
  myToast: any;
  selectProject: string | undefined;
  setSelectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  setProjectsShow: React.Dispatch<React.SetStateAction<boolean>>;
  setTeamId: any;
  setGenerateReport: React.Dispatch<React.SetStateAction<boolean>>;
  selectViewOptions: string; 
  setSelectViewOptions: React.Dispatch<React.SetStateAction<string>>; 
  selectOption:string;
  setSelectOption:React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [toggleNav, setToggleNav] = useState("open");

  const openNav = () =>
    setToggleNav((state) => (state === "open" ? "close" : "open"));

  const TypesOfReports = [
    { label: "Task Report", value: "task" },
    { label: "Project TimeLog Report", value: "project" },
    { label: "Leave Report", value: "leave" },
    {label:"Employee Leave Tracker Summary",value:"summary"}
  ];

  useEffect(() => {
    setSelectedProject(undefined);
    setSelectAssignee(undefined);
    setSelectTeam(undefined);
    setSelectEmployee(undefined);
    setSelectDates(undefined);     
  }, [reportType]);

  return (
    <div className="collapse-box-wrap">
      <div className={`collapse-box slider-menu-crtd ${toggleNav}`}>
        <div className="d-flex col-head">
          <p>Report Type</p>
          <button onClick={openNav}>
            <span className="material-icons-round">keyboard_arrow_left</span>
          </button>
        </div>
        <div className="report-slider-menu">
          <div className="d-flex report-type-slect-block">
            <div className="d-flex drpdwn-slct status-slct task-slct">
              <div className="user-image-block-sm">
                <span className="material-icons-outlined">done_outline</span>
              </div>
              <Dropdown
                name="typesofreports"
                optionLabel="label"
                optionValue="value"
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                options={TypesOfReports}
                placeholder="Select"
              />
            </div>
          </div>
          {reportType === "task" ? (
            <TaskFilterList
              projectList={projectList}
              assigneesList={assigneesList}
              selectedProject={selectedProject}
              selectedAssignee={selectedAssignee}
              selectedDates={selectedDates}
              setSelectedProject={setSelectedProject}
              setSelectAssignee={setSelectAssignee}
              setSelectDates={setSelectDates}
              selectedGroup={selectedGroup}
              setShow={setShow}
              setSelectedGroup={setSelectedGroup}
              groupOptions={groupOptions}
            />
          ) : (
            ""
          )}

          {reportType === "project" ? (
            <ProjectFilterList
              projectList={projectList}
              myToast={myToast}
              setProjectsShow={setProjectsShow}
              selectedRange={selectedRange}
              setSelectRange={setSelectRange}
              selectedDates={selectedDates}
              setSelectDates={setSelectDates}
              selectProject={selectProject}
              setSelectProject={setSelectProject}
            />
          ) : (
            ""
          )}

          {reportType === "leave" ? (
            <LeaveReportFilterList
              teamList={teamList}
              employeeList={employeeList}
              selectedTeam={selectedTeam}
              selectedEmployee={selectedEmployee}
              selectedDates={selectedDates}
              setSelectTeam={setSelectTeam}
              setSelectEmployee={setSelectEmployee}
              setSelectDates={setSelectDates}
              setLeaveShow={setLeaveShow}
              selectedRange={selectedRange}
              setSelectRange={setSelectRange}
              myToast={myToast}
              setTeamId={setTeamId}
              setGenerateReport={setGenerateReport}
              selectViewOptions={selectViewOptions}
              setSelectViewOptions={setSelectViewOptions} 
            />
          ) : (
            ""
          )}


          {
            reportType ==="summary" ?(
             <LeaveSummaryReportFilterList teamList={teamList}
              employeeList={employeeList}
              selectedTeam={selectedTeam}
              selectedEmployee={selectedEmployee}
              selectedDates={selectedDates}
              setSelectTeam={setSelectTeam}
              setSelectEmployee={setSelectEmployee}
              setSelectDates={setSelectDates}
              setLeaveShow={setLeaveShow}
              selectedRange={selectedRange}
              setSelectRange={setSelectRange}
              myToast={myToast}
              setTeamId={setTeamId}
              setGenerateReport={setGenerateReport}
              selectViewOptions={selectOption}
              setSelectViewOptions={setSelectOption} />
            ):("")
          }
        </div>
      </div>
    </div>
  );
};

const ProjectFilterList = ({
  projectList,
  selectProject,
  setSelectProject,
  setProjectsShow,
  myToast,
  selectedRange,
  setSelectRange,
  setSelectDates,
  selectedDates,
}: {
  projectList: ProjectList[];
  setSelectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectProject: string | undefined;
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >;
  selectedDates: Date | Date[] | undefined;
  selectedRange: string | undefined;
  myToast: any;
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>;
  setProjectsShow: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  // Sort the projectList alphabetically by project_name
  const sortedProjectList = [...projectList].sort((a, b) =>
    a.project_name.localeCompare(b.project_name)
  );

  return (
    <>
      <div className="col-bd-ele">
        <div className="report-filter">
          <div className="report-filter-item">
            <label> Project </label>
            <div className="d-flex drpdwn-slct status-slct">
              <Dropdown
                name="roleId"
                optionLabel="project_name"
                optionValue="_id"
                value={selectProject}
                onChange={(e) => {
                  setSelectProject(e.target.value);
                  setProjectsShow(false);
                }}
                options={sortedProjectList}
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Date Range </label>
            <div className="d-flex drpdwn-slct status-slct">
              <Calendar
                selectionMode="range"
                value={selectedDates}
                onChange={(e) => {
                  setSelectDates(e.value);
                  setProjectsShow(false);
                }}
                maxDate={new Date()}
              />
            </div>
          </div>

          <div className="report-filter-item d-flex check-box-group-ui">
            <div className="check-label-ui">
              <RadioButton
                inputId="range_type"
                id="day-radio"
                name="range_type"
                value="date"
                onChange={(e) => {
                  setSelectRange(e.target.value);
                  setProjectsShow(false);
                }}
                checked={selectedRange === "date"}
              />
              <label htmlFor="list-radio" className="p-radiobutton-label">
                <span>Daily</span>
              </label>
            </div>
            <div className="check-label-ui">
              <RadioButton
                inputId="range_type"
                id="week-radio"
                name="range_type"
                value="week"
                onChange={(e) => {
                  setSelectRange(e.target.value);
                  setProjectsShow(false);
                }}
                checked={selectedRange === "week"}
              />
              <label htmlFor="list-radio" className="p-radiobutton-label">
                <span>Weekly</span>
              </label>
            </div>
            <div className="check-label-ui">
              <RadioButton
                inputId="range_type"
                id="month-radio"
                name="range_type"
                value="month"
                onChange={(e) => {
                  setSelectRange(e.target.value);
                  setProjectsShow(false);
                }}
                checked={selectedRange === "month"}
              />
              <label htmlFor="list-radio" className="p-radiobutton-label">
                <span>Monthly</span>
              </label>
            </div>
          </div>

          <div className="report-filter-item">
            <label> Report View </label>
            <div className="d-flex">
              <div className="up-in-toggle">
                <input type="radio" id="switch_left" name="switch_2" checked />
                <label htmlFor="switch_left">
                  <span className="material-icons-outlined">assessment</span>{" "}
                  Chart In
                </label>
                <input
                  type="radio"
                  id="switch_right"
                  name="switch_2"
                  onClick={() => showToast("warn", "", "Coming soon...")}
                />
                <label htmlFor="switch_right">
                  <span className="material-icons-outlined">grid_on</span> Table
                  Up
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-right-action">
        <button
          type="button"
          className="btn cancel"
          onClick={() =>
            ResetProjectSelection(
              setProjectsShow,
              setSelectProject,
              setSelectDates,
              setSelectRange
            )
          }
        >
          Reset
        </button>
        <button
          type="button"
          className="btn save"
          onClick={() => setProjectsShow(true)}
        >
          Submit
        </button>
      </div>
    </>
  );
};

const LeaveReportFilterList = ({
  teamList,
  employeeList,
  selectedTeam,
  selectedEmployee,
  selectedDates,
  setSelectTeam,
  setSelectEmployee,
  setSelectDates,
  setLeaveShow,
  myToast,
  selectedRange,
  setSelectRange,
  setTeamId,
  setGenerateReport,
  selectViewOptions,
  setSelectViewOptions,
}: {
  teamList: TeamsList[];
  employeeList: EmployeeList[];
  selectedTeam: string | undefined;
  selectedEmployee: string | undefined;
  selectedDates: Date | Date[] | undefined;
  setSelectTeam: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectEmployee: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >;
  myToast: any;
  selectedRange: string | undefined;
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>;
  setLeaveShow: React.Dispatch<React.SetStateAction<boolean>>;
  setTeamId: any;
  setGenerateReport: React.Dispatch<React.SetStateAction<boolean>>;
  selectViewOptions:string | undefined;
  setSelectViewOptions: React.Dispatch<React.SetStateAction<string>>;

}) => {
  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const sortedTeamList = [...teamList].sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  const sortedEmployeeList = [...employeeList].sort((a, b) =>
    a.profile.first_name.localeCompare(b.profile.first_name)
  );

  return (
    <>
      <div className="col-bd-ele">
        <div className="report-filter">
          <div className="report-filter-item">
            <label> Team/Department</label>
            <div className="d-flex drpdwn-slct status-slct">
              <MultiSelect
                name="team"
                optionLabel="name"
                optionValue="_id"
                value={selectedTeam}
                onChange={(e) => {
                  const selectedTeam = e.target.value;
                  setSelectTeam(selectedTeam);
                  setTeamId(selectedTeam || "All");
                  setLeaveShow(false);
                }}
                options={sortedTeamList}
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Person </label>
            <div className="d-flex drpdwn-slct status-slct">
              <MultiSelect
                name="employees"
                optionLabel="fullName"
                optionValue="id"
                value={selectedEmployee}
                onChange={(e) => {
                  setSelectEmployee(e.target.value);
                  setLeaveShow(false);
                }}
                options={
                  selectedTeam
                    ? sortedEmployeeList.map((employee) => ({
                        ...employee,
                        fullName: `${employee.profile.first_name} ${employee.profile.last_name}`,
                      }))
                    : []
                }
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Date Range </label>
            <div className="d-flex drpdwn-slct status-slct">
              <Calendar
                selectionMode="range"
                value={selectedDates}
                onChange={(e) => {
                  setSelectDates(e.value);
                  setLeaveShow(false);
                }}
              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Report View </label>
            <div className="d-flex">
              <div className="up-in-toggle">
                <input type="radio" id="switch_left" name="switch_2"
                 checked={selectViewOptions === "chart"}
                 onChange={() => setSelectViewOptions("chart")} 
                 />
                <label htmlFor="switch_left">
                  <span className="material-icons-outlined">assessment</span>{" "}
                  Chart In
                </label>
                <input
                  type="radio"
                  id="switch_right"
                  name="switch_2"
                  checked={selectViewOptions === "table"}
                  onChange={() => setSelectViewOptions("table")} 
                                />
                <label htmlFor="switch_right">
                  <span className="material-icons-outlined">grid_on</span> Table
                  Up
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-right-action">
        <button
          type="button"
          className="btn cancel"
          onClick={() =>
            ResetLeaveReportSelection(
              setLeaveShow,
              setSelectTeam,
              setSelectEmployee,
              setSelectDates,
              setSelectRange
            )
          }
        >
          Reset
        </button>
        <button
          type="button"
          className="btn save"
          onClick={() => {
            setSelectRange("date"); 
            setLeaveShow(true);
            setGenerateReport(true);
          }}
        >
          Submit
        </button>
      </div>
    </>
  );
};


const LeaveSummaryReportFilterList=({
  teamList,
  employeeList,
  selectedTeam,
  selectedEmployee,
  selectedDates,
  setSelectTeam,
  setSelectEmployee,
  setSelectDates,
  setLeaveShow,
  myToast,
  selectedRange,
  setSelectRange,
  setTeamId,
  setGenerateReport,
  selectViewOptions,
  setSelectViewOptions,
}: {
  teamList: TeamsList[];
  employeeList: EmployeeList[];
  selectedTeam: string | undefined;
  selectedEmployee: string | undefined;
  selectedDates: Date | Date[] | undefined;
  setSelectTeam: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectEmployee: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >;
  myToast: any;
  selectedRange: string | undefined;
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>;
  setLeaveShow: React.Dispatch<React.SetStateAction<boolean>>;
  setTeamId: any;
  setGenerateReport: React.Dispatch<React.SetStateAction<boolean>>;
  selectViewOptions:string | undefined;
  setSelectViewOptions: React.Dispatch<React.SetStateAction<string>>;

}) => {
  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const sortedTeamList = [...teamList].sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  const sortedEmployeeList = [...employeeList].sort((a, b) =>
    a.profile.first_name.localeCompare(b.profile.first_name)
  );

  return (
    <>
      <div className="col-bd-ele">
        <div className="report-filter">
          <div className="report-filter-item">
            <label> Team/Department</label>
            <div className="d-flex drpdwn-slct status-slct">
              <MultiSelect
                name="team"
                optionLabel="name"
                optionValue="_id"
                value={selectedTeam}
                onChange={(e) => {
                  const selectedTeam = e.target.value;
                  setSelectTeam(selectedTeam);
                  setTeamId(selectedTeam || "All");
                  setLeaveShow(false);
                }}
                options={sortedTeamList}
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Person </label>
            <div className="d-flex drpdwn-slct status-slct">
              <MultiSelect
                name="employees"
                optionLabel="fullName"
                optionValue="id"
                value={selectedEmployee}
                onChange={(e) => {
                  setSelectEmployee(e.target.value);
                  setLeaveShow(false);
                }}
                options={
                  selectedTeam
                    ? sortedEmployeeList.map((employee) => ({
                        ...employee,
                        fullName: `${employee.profile.first_name} ${employee.profile.last_name}`,
                      }))
                    : []
                }
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Date Range </label>
            <div className="d-flex drpdwn-slct status-slct">
              <Calendar
                selectionMode="range"
                value={selectedDates}
                onChange={(e) => {
                  setSelectDates(e.value);
                  setLeaveShow(false);
                }}
                maxDate={new Date()}

              />
            </div>
          </div>

          <div className="report-filter-item">
            <label> Report View </label>
            <div className="d-flex">
              <div className="up-in-toggle">
                <input type="radio" id="switch_left" name="switch_2"
                 onClick={() => showToast("warn", "", "Coming soon...")}

                 />
                <label htmlFor="switch_left">
                  <span className="material-icons-outlined">assessment</span>{" "}
                  Chart In
                </label>
                <input
                  type="radio"
                  id="switch_right"
                  name="switch_2"
                  checked={selectViewOptions === "table"}
                  onChange={() => setSelectViewOptions("table")} 
                                />
                <label htmlFor="switch_right">
                  <span className="material-icons-outlined">grid_on</span> Table
                  Up
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-right-action">
        <button
          type="button"
          className="btn cancel"
          onClick={() =>
            ResetLeaveSummaryReportSelection(
              setLeaveShow,
              setSelectTeam,
              setSelectEmployee,
              setSelectDates,
              setSelectRange
            )
          }
        >
          Reset
        </button>
        <button
          type="button"
          className="btn save"
          onClick={() => {
            setSelectRange("date"); 
            setLeaveShow(true);
            setGenerateReport(true);
          }}
        >
          Submit
        </button>
      </div>
    </>
  );
};

const ResetLeaveReportSelection = (
  setLeaveShow: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectTeam: React.Dispatch<React.SetStateAction<string | undefined>>,
  setSelectEmployee: React.Dispatch<React.SetStateAction<string | undefined>>,
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >,
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>
) => {
  setLeaveShow(false);
  setSelectTeam(undefined);
  setSelectEmployee(undefined);
  setSelectDates(undefined);
  setSelectRange(undefined);
};

const ResetLeaveSummaryReportSelection=(
  setLeaveShow: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectTeam: React.Dispatch<React.SetStateAction<string | undefined>>,
  setSelectEmployee: React.Dispatch<React.SetStateAction<string | undefined>>,
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >,
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>
) => {
  setLeaveShow(false);
  setSelectTeam(undefined);
  setSelectEmployee(undefined);
  setSelectDates(undefined);
  setSelectRange(undefined);
};

const ResetProjectSelection = (
  setProjectsShow: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectProject: React.Dispatch<React.SetStateAction<string | undefined>>,
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >,
  setSelectRange: React.Dispatch<React.SetStateAction<string | undefined>>
) => {
  setProjectsShow(false);
  setSelectProject(undefined);
  setSelectDates(undefined);
  setSelectRange(undefined);
};

const TaskFilterList = ({
  projectList,
  assigneesList,
  selectedProject,
  selectedAssignee,
  selectedDates,
  setSelectedProject,
  setSelectAssignee,
  setSelectDates,
  setShow,
  setSelectedGroup,
  selectedGroup,
  groupOptions,
}: {
  projectList: ProjectList[];
  assigneesList: AssigneesList[];
  selectedProject: string[] | undefined;
  selectedAssignee: string[] | undefined;
  selectedDates: Date | Date[] | undefined;
  setSelectedProject: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
  setSelectAssignee: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedGroup: React.Dispatch<React.SetStateAction<optionItems>>;
  selectedGroup: optionItems;
  groupOptions: optionItems;
}) => {
  const [isGetReportClicked, setIsGetReportClicked] = useState(false);

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
          style={{ width: 15 }}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
            style={{ width: 15 }}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props}</span>;
  };

  const handleGetReportClick = () => {
    setShow(true);
    setIsGetReportClicked(true);
  };

  const handleResetClick = () => {
    cancelFilterList(
      setSelectedProject,
      setSelectAssignee,
      setSelectDates,
      setSelectedGroup,
      groupOptions
    );
  };

  // Handle changes in the filter fields and enable the Get Report button
  const handleFilterChange = (
    setter: React.Dispatch<React.SetStateAction<any>>,
    value: any
  ) => {
    setter(value);
    setShow(false);
    setIsGetReportClicked(false); // Re-enable the Get Report button when any filter changes
  };

  // Sort the projectList alphabetically by project_name
  const sortedProjectList = [...projectList].sort((a, b) =>
    a.project_name.localeCompare(b.project_name)
  );

  //Sort the assigneesList alphabetically by assignee_name and remove duplicate the assignee
  const sortAssigneeList = [...assigneesList]
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter(
      (assignee, index, self) =>
        index === self.findIndex((t) => t.name === assignee.name)
    );

  return (
    <>
      <div className="col-bd-ele">
        <div className="report-filter">
          <div className="report-filter-item">
            <label> Project</label>
            <div className="d-flex drpdwn-slct status-slct">
              <MultiSelect
                name="projects"
                optionLabel="project_name"
                optionValue="_id"
                value={selectedProject}
                onChange={(e) =>
                  handleFilterChange(setSelectedProject, e.target.value)
                }
                options={sortedProjectList}
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>
          <div className="report-filter-item">
            <label> Assignees </label>
            <div className="d-flex drpdwn-slct status-slct">
              <MultiSelect
                name="assignees"
                optionLabel="name"
                optionValue="_id"
                value={selectedAssignee}
                onChange={(e) =>
                  handleFilterChange(setSelectAssignee, e.target.value)
                }
                options={sortAssigneeList}
                itemTemplate={assgineesOptionTemplate}
                // selectedItemTemplate={selectedAssgineesTemplate}
                placeholder="Select"
                filter
                resetFilterOnHide={true}
              />
            </div>
          </div>
          <div className="report-filter-item">
            <label> Date Range </label>
            <div className="d-flex drpdwn-slct p-multiselect status-slct">
              <Calendar
                selectionMode="range"
                value={selectedDates}
                onChange={(e) => handleFilterChange(setSelectDates, e.value)}
                maxDate={new Date()}
              />
              <div className="p-multiselect-trigger">
                <span className="p-multiselect-trigger-icon p-c pi pi-chevron-down"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-bd-ele">
        <h3 className="group-by-title"> Group by </h3>
        <GroupByList
          selectedGroup={selectedGroup}
          setSelectedGroup={(value) =>
            handleFilterChange(setSelectedGroup, value)
          }
          setShow={setShow}
        />
      </div>
      <div className="footer-right-action">
        <button
          type="button"
          className="btn cancel"
          onClick={handleResetClick}
          // disabled={!isGetReportClicked}
        >
          Reset
        </button>
        <button
          type="button"
          className="btn save"
          onClick={handleGetReportClick}
          disabled={isGetReportClicked}
        >
          Get Report
        </button>
      </div>
    </>
  );
};

const cancelFilterList = (
  setSelectedProject: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >,
  setSelectAssignee: React.Dispatch<React.SetStateAction<string[] | undefined>>,
  setSelectDates: React.Dispatch<
    React.SetStateAction<Date | Date[] | undefined>
  >,
  setSelectedGroup: React.Dispatch<React.SetStateAction<optionItems>>,
  groupOptions: optionItems
) => {
  setSelectedProject(undefined);
  setSelectAssignee(undefined);
  setSelectDates(undefined);
  setSelectedGroup(groupOptions);
};

const GroupByList = ({
  selectedGroup,
  setSelectedGroup,
  setShow,
}: {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedGroup: optionItems;
  setSelectedGroup: React.Dispatch<React.SetStateAction<optionItems>>;
}) => {
  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(selectedGroup);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setSelectedGroup(items);
    setShow(false);
  };
  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="grouplist">
        {(provided) => (
          <div
            className="drap-menu-group"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {selectedGroup.map(({ label, value }, index) => {
              return (
                <Draggable key={value} draggableId={value} index={index}>
                  {(provided) => (
                    <div
                      className="drap-menu-item"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <span className="material-icons-outlined">
                        drag_indicator
                      </span>
                      <span> {label} </span>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const ReportsHeader = ({
  title,
  total,
  myToast,
  selectViewOptions,
}: {
  title: string;
  total: ReportListTotal | any;
  myToast: any;
  selectViewOptions:string;
}) => {
  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  return (
    <div className="mn-dtls-vw container">
      <div className="d-flex dtls-top-sec">
        <div className="d-flex task-nm-dtls">
          <p>{title}</p>
        </div>
        <div className="d-flex task-dp-dtls">
          {(title === "Leave Report" || title === "Employee Leave Tracker Summary") && selectViewOptions !=="table" ? (
            <div className="d-flex tsk-counts">
              <div className="d-flex">
                <p className="lab-dot"></p>
                <p>{total?.totalCL} CL</p>
              </div>
              <div className="d-flex">
                <p className="lab-dot"></p>
                <p>{total?.totalSL} SL</p>
              </div>
              {total?.totalPL > 0 && (
                <div className="d-flex">
                  <p className="lab-dot"></p>
                  <p>{total?.totalPL} PL</p>
                </div>
              )}

              {/* <div className="d-flex">
                <p className="lab-dot"></p>
                <p>{total?.totalLeaves} Leave Taken</p>
              </div> */}
            </div>
          ) : (
            title !== "Leave Report" && title !== "Employee Leave Tracker Summary" && (
            <div className="d-flex tsk-counts">
              
              <div className="d-flex">
                <p className="lab-dot"></p>
                <p>{total?.totalProjects} Projects</p>
              </div>
              <div className="d-flex">
                <p className="lab-dot"></p>
                <p>{total?.totalTasks} Tasks</p>
              </div>
              <div className="d-flex">
                <p className="lab-dot"></p>
                <p>{total?.totalSubTasks} Sub Tasks</p>
              </div>
            </div>
            )
          )}

          <div className="d-flex more-opt">
            <button
              className="more-btn open"
              onClick={() => showToast("warn", "", "Coming soon...")}
            >
              <span className="material-icons-round">more_vert</span>
            </button>
          </div>
        </div>
      </div>
      {/* Button */}
      {/* table */}

   
    </div>
  );
};


const formatCustomDate = (dateString: string | number | Date) => {
  const date = new Date(dateString);
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();
  
  const hours = date.getHours() % 12 || 12; // Convert 24hr to 12hr format
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const period = date.getHours() >= 12 ? 'PM' : 'AM';

  return `${day} ${month} ${year} ${hours}:${minutes} ${period}`;
};
const LeaveReportList = ({
  selectedTeam,
  selectedEmployee,
  selectedRange,
  selectedDates,
  selectViewOptions,
  myToast,
}: {
  myToast: any;
  selectedTeam: string | undefined;
  selectedEmployee: string | undefined;
  selectedRange: string | undefined;
  selectedDates: Date | Date[];
  selectViewOptions: string;
}) => {
  let startDate = "";
  let endDate = "";
  if (selectedDates) {
    const date = selectedDates.toString().split(",");
    startDate = dateBeautify(date[0]);
    endDate = dateBeautify(date[1]);
  }

  // Fetch leave report data and loading state
  const { leaveReportList, isLeaveReportLoading } = useLeaveReportList(
    selectedTeam,
    selectedEmployee,
    selectedRange,
    startDate,
    endDate
  );

  const {fullLeaveReportList}=useFullLeaveReportList(
    selectedTeam,
    selectedEmployee,
    selectedRange,
    startDate,
    endDate
  )

  
  const formattedData = fullLeaveReportList?.map((entry: any, index: number) => ({
    sno: index + 1,
    employeeName:entry.employeeName,
    description: entry.title, 
    createdDate: new Date(entry.createdAt).toLocaleDateString(), 
    leaveStartDate: formatCustomDate(entry.start_date), 
    leaveEndDate: formatCustomDate(entry.end_date),
    leaveType: entry.leaveTypeName, 
    leaveDurationType:entry.leaveDurationInDays,
    status: entry.status,
    approverName:entry.approverName,
  }));


   // Function to download CSV
  const downloadCSV = () => {
    if (!formattedData.length) {
      myToast?.show({ severity: "warn", summary: "No Data", detail: "No leave records to download." });
      return;
    }

    const csvData = Papa.unparse(formattedData);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "leave_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Fetch total leave report data
  const { reportListTotal } = useLeaveReportListTotal(
    selectedTeam,
    selectedEmployee,
    startDate,
    endDate
  );

  // Apply random colors to datasets for better visualization
  if (leaveReportList) {
    leaveReportList.datasets = leaveReportList?.datasets?.map((item: any) => ({
      ...item,
      backgroundColor: randomColor({
        luminosity: "light",
        format: "rgb",
      }),
    }));
  }

  if (isLeaveReportLoading) {
    return <DataLoading />;
  }

  return (
    <div className="task-top-table-separate">
      <ReportsHeader
        title={"Leave Report"}
        total={reportListTotal}
        myToast={myToast}
        selectViewOptions={selectViewOptions}
      />
      {selectViewOptions && selectViewOptions === "chart" ? (
        <div className="main-data-block">
          <section className="main-section report-main-block">
            <div className="d-flex count-manage-ui count-manage-main-screen working-duration">
              {leaveReportList && (
                <Bar
                  datasetIdKey="id"
                  data={{
                    labels: leaveReportList?.labels || "NA", // Employee names
                    datasets: leaveReportList.datasets || 0, // Leave data for each type
                  }}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: "top",
                      },
                      title: {
                        display: true,
                        text: "Employee Leave Report",
                      },
                    },
                    scales: {
                      x: {
                        title: {
                          display: true,
                          text: "Employees",
                        },
                      },
                      y: {
                        title: {
                          display: true,
                          text: "Leave Count",
                        },
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              )}
            </div>
          </section>
        </div>
      ) : (
        <div className="mn-dtls-vw container">
        <div className="tsk-btn floating-btn-comp">
              <button
                className={`d-flex 
                  "bg-opacity-25 bg-success"
                }`}
                type="button"
                onClick={downloadCSV}
              >
                <span className="material-icons-round">download</span>
                <p>Download</p>
              </button>
              </div>
          <div className="table-responsive">
            {formattedData?.length >0 ?(
              <table 
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Employee Name</th>
                    <th>Leave Description</th>
                    <th>Leave Type</th>
                    <th>Leave Duration </th>
                    <th>Approver Name</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {formattedData.map((row:any, idx:any) => (
                    <tr key={idx} 
                    // style={{
                    //   backgroundColor: idx % 2 === 0 ? '#f9f9f9' : '#ffffff',
                    //   border: '1px solid #ddd'
                    // }}
                    >
                      <td>{row.sno}</td>
                      <td>{row.employeeName}</td>
                      <td>{row.description}</td>              
                      <td>{row.leaveType}</td>
                      <td>{row.leaveDurationType}</td>
                      <td>{row.approverName}</td>
                      <td>{row.leaveStartDate}</td>
                      <td>{row.leaveEndDate}</td>
                      <td>{row.status}</td>
                      <td>{row.createdDate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>):( <p>No leave records found</p>)}
        </div>
      </div>
       
      )}
    </div>
  );
};

const LeaveSummaryReportList = ({
  selectedTeam,
  selectedEmployee,
  selectedRange,
  selectedDates,
  selectViewOptions,
  myToast,
}: {
  myToast: any;
  selectedTeam: string | undefined;
  selectedEmployee: string | undefined;
  selectedRange: string | undefined;
  selectedDates: Date | Date[];
  selectViewOptions: string;
}) => {
  let startDate = "";
  let endDate = "";
  if (selectedDates) {
    const date = selectedDates.toString().split(",");
    startDate = dateBeautify(date[0]);
    endDate = dateBeautify(date[1]);
  }

  // Fetch leave report data and loading state
  const { leaveReportList, isLeaveReportLoading } = useLeaveReportList(
    selectedTeam,
    selectedEmployee,
    selectedRange,
    startDate,
    endDate
  );

  const {employeeLeaveTrackerReportList}=useEmployeeLeaveTrackerReportList(
    selectedTeam,
    selectedEmployee,
    selectedRange,
    startDate,
    endDate
  )

  const formattedData = Object.entries(employeeLeaveTrackerReportList as EmployeeLeaveTrackerReportList).map(
    ([employeeName, leaveData], index) => ({
      sno: index + 1,
      employeeName,
      casualLeave: (
        <>
          <span className="material-icons-round">done_outline</span> {leaveData?.casual_leave || 0} 
          <span className="material-icons-round">close</span> {leaveData?.cl_pending || 0}
        </>
      ),      
      sickLeave: (
        <>
          <span className="material-icons-round">done_outline</span> {leaveData?.sick_leave || 0} 
          <span className="material-icons-round">close</span> {leaveData?.sl_pending || 0}
        </>
      ),
      privilegedLeave: (
        <>
          <span className="material-icons-round">done_outline</span> {leaveData?.privileged_leave === "NA" || leaveData?.privileged_leave === undefined 
            ? 'NA' 
            : leaveData?.privileged_leave} 
          <span className="material-icons-round">close</span> {leaveData?.pl_pending === "NA" || leaveData?.pl_pending === undefined 
            ? 'NA' 
            : leaveData?.pl_pending}
        </>
      ),
      wfh: (
        <>
          <span className="material-icons-round">done_outline</span> {leaveData?.wfh || 0} 
          <span className="material-icons-round">close</span> {leaveData?.wfh_pending || 0}
        </>
      ),
      permission: (
        <>
          <span className="material-icons-round">done_outline</span> {leaveData?.permission || 0} 
          <span className="material-icons-round">close</span> {leaveData?.permission_pending || 0}
        </>
      ),
    })
  );


   // Function to download CSV
  const downloadCSV = () => {
    if (!formattedData.length) {
      myToast?.show({ severity: "warn", summary: "No Data", detail: "No leave records to download." });
      return;
    }

    const csvData = Papa.unparse(formattedData);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "leave_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Fetch total leave report data
  const { reportListTotal } = useLeaveReportListTotal(
    selectedTeam,
    selectedEmployee,
    startDate,
    endDate
  );

  // Apply random colors to datasets for better visualization
  if (leaveReportList) {
    leaveReportList.datasets = leaveReportList?.datasets?.map((item: any) => ({
      ...item,
      backgroundColor: randomColor({
        luminosity: "light",
        format: "rgb",
      }),
    }));
  }

  if (isLeaveReportLoading) {
    return <DataLoading />;
  }

  return (
    <div className="task-top-table-separate">
      <ReportsHeader
        title={"Employee Leave Tracker Summary"}
        total={reportListTotal}
        myToast={myToast}
        selectViewOptions={selectViewOptions}
      />
      {selectViewOptions && selectViewOptions === "chart" ? (
        <div className="main-data-block">
          <section className="main-section report-main-block">
            <div className="d-flex count-manage-ui count-manage-main-screen working-duration">
              {leaveReportList && (
                <Bar
                  datasetIdKey="id"
                  data={{
                    labels: leaveReportList?.labels || "NA", // Employee names
                    datasets: leaveReportList.datasets || 0, // Leave data for each type
                  }}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: "top",
                      },
                      title: {
                        display: true,
                        text: "Employee Leave Tracker Summary",
                      },
                    },
                    scales: {
                      x: {
                        title: {
                          display: true,
                          text: "Employees",
                        },
                      },
                      y: {
                        title: {
                          display: true,
                          text: "Leave Count",
                        },
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              )}
            </div>
          </section>
        </div>
      ) : (
        <div className="mn-dtls-vw container">
        <div className="tsk-btn floating-btn-comp">
              <button
                className={`d-flex 
                  "bg-opacity-25 bg-success"
                }`}
                type="button"
                onClick={downloadCSV}
              >
                <span className="material-icons-round">download</span>
                <p>Download</p>
              </button>
        </div>
        <div className="table-responsive">
  
      {formattedData?.length >0 ?(
         <table 
         >
          <thead>
            <tr>
            <th>S.No</th>
              <th>Employee Name</th>
              <th>Casual Leave(in Days)</th>
              <th>Sick Leave(in Days)</th>
              <th>Privileged Leave(in Days)</th>
              <th>WFH(in Days)</th>
              <th>Permission(in Hrs)</th>
            </tr>
          </thead>
          <tbody>
            {formattedData.map((row:any, idx:any) => (
              <tr key={idx} 
              >
                <td>{row.sno}</td>
                <td>{row.employeeName}</td>
                <td>{row.casualLeave}</td>
                <td>{row.sickLeave}</td>
                <td>{row.privilegedLeave}</td>
                <td>{row.wfh}</td>
                <td>{row.permission}</td>
              </tr>
            ))}
          </tbody>
        </table>):( <p>No leave records found</p>)}
        </div>
      </div>
       
      )}
    </div>
  );
};
const PADReportList = ({ reports }: { reports: any }) => {
  return (
    <div className="tsk-lists">
      <div className="d-flex list-tr list-headings">
        <div className="d-flex rpt-pjt-wid">Project</div>
        <div className="d-flex rpt-asg-wid">Assignees</div>
        <div className="d-flex rpt-dte-wid">Date</div>
        <div className="d-flex rpt-tsk-wid">
          <span>Task</span>
        </div>
        <div className="d-flex rpt-hrs-wid">Hours Spent</div>
      </div>
      <div className="rpt-lst-main">
        {reports.map(
          (
            {
              projects,
              assignees,
              dates,
              tasks,
            }: {
              projects: ProjectType;
              assignees: AssigneeType[];
              dates: DateType[];
              tasks: any;
            },
            index: number
          ) => (
            <div className="d-flex rpt-lst-item" key={index}>
              <div className="d-flex list-tr">
                <div className="rpt-pjt-wid">
                  <ProjectTile {...projects} boxSize={tasks.length} />
                </div>

                <div className="rpt-asg-wid">
                  {assignees.map((assignee: any) => (
                    <AssigneeTile {...assignee} />
                  ))}
                </div>

                <div className="rpt-dte-wid">
                  {dates.map((date: any) => (
                    <DateTile {...date} />
                  ))}
                </div>
                <div className="rpt-tsk-wid">
                  {tasks.map((task: any) => (
                    <TaskTile {...task} />
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const PDAReportList = ({ reports }: { reports: any }) => {
  return (
    <div className="tsk-lists">
      <div className="d-flex list-tr list-headings">
        <div className="d-flex rpt-pjt-wid">Project</div>
        <div className="d-flex rpt-dte-wid">Date</div>
        <div className="d-flex rpt-asg-wid">Assignees</div>
        <div className="d-flex rpt-tsk-wid">Task</div>
        <div className="d-flex rpt-hrs-wid">Hours Spent</div>
      </div>
      <div className="rpt-lst-main">
        {reports.map(
          ({
            projects,
            assignees,
            dates,
            tasks,
          }: {
            projects: ProjectType;
            assignees: AssigneeType[];
            dates: DateType[];
            tasks: TaskType[];
          }) => (
            <div className="d-flex rpt-lst-item">
              <div className="d-flex list-tr">
                <div className="rpt-pjt-wid">
                  <ProjectTile {...projects} boxSize={tasks.length} />
                </div>
                <div className="rpt-dte-wid">
                  {dates.map((date: any) => (
                    <DateTile {...date} />
                  ))}
                </div>
                <div className="rpt-asg-wid">
                  {assignees.map((assignee: any) => (
                    <AssigneeTile {...assignee} />
                  ))}
                </div>
                <div className="rpt-tsk-wid">
                  {tasks.map((task: any) => (
                    <TaskTile {...task} />
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const APDReportList = ({ reports }: { reports: any }) => {
  return (
    <div className="tsk-lists">
      <div className="d-flex list-tr list-headings">
        <div className="d-flex rpt-pjt-wid">Assignees</div>
        <div className="d-flex rpt-dte-wid">Project</div>
        <div className="d-flex rpt-asg-wid">Date</div>
        <div className="d-flex rpt-tsk-wid">
          <span>Task</span>
        </div>
        <div className="d-flex rpt-hrs-wid">Hours Spent</div>
      </div>
      <div className="rpt-lst-main">
        {reports.map(
          ({
            projects,
            assignees,
            dates,
            tasks,
          }: {
            projects: ProjectType[];
            assignees: AssigneeType;
            dates: DateType[];
            tasks: TaskType[];
          }) => (
            <div className="d-flex rpt-lst-item">
              <div className="d-flex list-tr">
                <div className="rpt-pjt-wid">
                  <AssigneeTile {...assignees} boxSize={tasks.length} />
                </div>
                <div className="rpt-asg-wid">
                  {projects.map((project: any) => (
                    <ProjectTile {...project} />
                  ))}
                </div>
                <div className="rpt-dte-wid">
                  {dates.map((date: any) => (
                    <DateTile {...date} />
                  ))}
                </div>
                <div className="rpt-tsk-wid">
                  {tasks.map((task: any) => (
                    <TaskTile {...task} />
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const ADPReportList = ({ reports }: { reports: any }) => {
  return (
    <div className="tsk-lists">
      <div className="d-flex list-tr list-headings">
        <div className="d-flex rpt-pjt-wid">Assignees</div>
        <div className="d-flex rpt-dte-wid">Date</div>
        <div className="d-flex rpt-asg-wid">Project</div>
        <div className="d-flex rpt-tsk-wid">
          <span>Task</span>
        </div>
        <div className="d-flex rpt-hrs-wid">Hours Spent</div>
      </div>
      <div className="rpt-lst-main">
        {reports.map(
          ({
            projects,
            assignees,
            dates,
            tasks,
          }: {
            projects: ProjectType[];
            assignees: AssigneeType;
            dates: DateType[];
            tasks: TaskType[];
          }) => (
            <div className="d-flex rpt-lst-item">
              <div className="d-flex list-tr">
                <div className="rpt-pjt-wid">
                  <AssigneeTile {...assignees} boxSize={tasks.length} />
                </div>
                <div className="rpt-dte-wid">
                  {dates.map((date: any) => (
                    <DateTile {...date} />
                  ))}
                </div>
                <div className="rpt-asg-wid">
                  {projects.map((project: any) => (
                    <ProjectTile {...project} />
                  ))}
                </div>
                <div className="rpt-tsk-wid">
                  {tasks.map((task: any) => (
                    <TaskTile {...task} />
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const DPAReportList = ({ reports }: { reports: any }) => {
  return (
    <div className="tsk-lists">
      <div className="d-flex list-tr list-headings">
        <div className="d-flex rpt-pjt-wid">Date</div>
        <div className="d-flex rpt-dte-wid">Project</div>
        <div className="d-flex rpt-asg-wid">Assignees</div>
        <div className="d-flex rpt-tsk-wid">
          <span>Task</span>
        </div>
        {/* <div className="d-flex rpt-tsk-wid">
          <span>SubTask</span>
        </div> */}
        <div className="d-flex rpt-hrs-wid">Hours Spent</div>
      </div>
      <div className="rpt-lst-main">
        {reports.map(
          ({
            projects,
            assignees,
            dates,
            tasks,
          }: {
            projects: ProjectType[];
            assignees: AssigneeType[];
            dates: DateType;
            tasks: TaskType[];
          }) => (
            <div className="d-flex rpt-lst-item">
              <div className="d-flex list-tr">
                <div className="rpt-pjt-wid">
                  <DateTile {...dates} boxSize={tasks.length} />
                </div>
                <div className="rpt-asg-wid">
                  {projects.map((project: any) => (
                    <ProjectTile {...project} />
                  ))}
                </div>
                <div className="rpt-dte-wid">
                  {assignees.map((assignee: any) => (
                    <AssigneeTile {...assignee} />
                  ))}
                </div>
                <div className="rpt-tsk-wid">
                  {tasks.map((task: any) => (
                    <TaskTile {...task} />
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const DAPReportList = ({ reports }: { reports: any }) => {
  return (
    <div className="tsk-lists">
      <div className="d-flex list-tr list-headings">
        <div className="d-flex rpt-pjt-wid">Date</div>
        <div className="d-flex rpt-dte-wid">Assignees</div>
        <div className="d-flex rpt-asg-wid">Project</div>
        <div className="d-flex rpt-tsk-wid">
          <span>Task</span>
        </div>
        <div className="d-flex rpt-hrs-wid">Hours Spent</div>
      </div>
      <div className="rpt-lst-main">
        {reports.map(
          ({
            projects,
            assignees,
            dates,
            tasks,
          }: {
            projects: ProjectType[];
            assignees: AssigneeType[];
            dates: DateType;
            tasks: TaskType[];
          }) => (
            <div className="d-flex rpt-lst-item">
              <div className="d-flex list-tr">
                <div className="rpt-pjt-wid">
                  <DateTile {...dates} boxSize={tasks.length} />
                </div>
                <div className="rpt-dte-wid">
                  {assignees.map((assignee: any) => (
                    <AssigneeTile {...assignee} />
                  ))}
                </div>
                <div className="rpt-asg-wid">
                  {projects.map((project: any) => (
                    <ProjectTile {...project} />
                  ))}
                </div>
                <div className="rpt-tsk-wid">
                  {tasks.map((task: any) => (
                    <TaskTile {...task} />
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const ReportsTaskList = ({
  reportList,
  group,
  PADReport,
  showPADReport,
  PDAReport,
  showPDAReport,
  APDReport,
  showAPDReport,
  ADPReport,
  showADPReport,
  DAPReport,
  showDAPReport,
  DPAReport,
  showDPAReport,
}: {
  reportList: any;
  group: string[];
  PADReport: boolean;
  showPADReport: React.Dispatch<React.SetStateAction<boolean>>;
  PDAReport: boolean;
  showPDAReport: React.Dispatch<React.SetStateAction<boolean>>;
  APDReport: boolean;
  showAPDReport: React.Dispatch<React.SetStateAction<boolean>>;
  ADPReport: boolean;
  showADPReport: React.Dispatch<React.SetStateAction<boolean>>;
  DAPReport: boolean;
  showDAPReport: React.Dispatch<React.SetStateAction<boolean>>;
  DPAReport: boolean;
  showDPAReport: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  let reports: any;
  if (group[0] === "project") {
    if (group[1] === "assignees" && group[2] === "date") {
      reports = reportList.map(
        ({
          _id,
          projectName,
          assigneesList,
          projectTotal,
        }: {
          _id: string;
          projectName: string;
          assigneesList: string[];
          projectTotal: number;
        }) =>
          transformPADReportData({
            _id,
            projectName,
            assigneesList,
            projectTotal,
          })
      );
      showPADReport(true);
    } else if (group[1] === "date" && group[2] === "assignees") {
      reports = reportList.map(
        ({
          _id,
          projectName,
          dateList,
          projectTotal,
        }: {
          _id: string;
          projectName: string;
          dateList: string[];
          projectTotal: number;
        }) =>
          transformPDAReportData({ _id, projectName, dateList, projectTotal })
      );
      showPDAReport(true);
    }
  } else if (group[0] === "assignees") {
    if (group[1] === "project" && group[2] === "date") {
      reports = reportList.map(
        ({
          _id,
          profilepic,
          name,
          projectList,
          assigneesTotal,
        }: {
          _id: string;
          profilepic: string;
          name: string;
          projectList: string[];
          assigneesTotal: number;
        }) =>
          transformAPDReportData({
            _id,
            profilepic,
            name,
            projectList,
            assigneesTotal,
          })
      );
      showAPDReport(true);
    } else if (group[1] === "date" && group[2] === "project") {
      reports = reportList.map(
        ({
          _id,
          profilepic,
          name,
          dateList,
          assigneesTotal,
        }: {
          _id: string;
          profilepic: string;
          name: string;
          dateList: string[];
          assigneesTotal: number;
        }) =>
          transformADPReportData({
            _id,
            profilepic,
            name,
            dateList,
            assigneesTotal,
          })
      );
      showADPReport(true);
    }
  } else if (group[0] === "date") {
    if (group[1] === "project" && group[2] === "assignees") {
      reports = reportList.map(
        ({
          _id,
          projectList,
          dateTotal,
        }: {
          _id: string;
          projectList: string[];
          dateTotal: number;
        }) => transformDPAReportData({ _id, projectList, dateTotal })
      );
      showDPAReport(true);
    } else if (group[1] === "assignees" && group[2] === "project") {
      reports = reportList.map(
        ({
          _id,
          assigneesList,
          dateTotal,
        }: {
          _id: string;
          assigneesList: string[];
          dateTotal: number;
        }) => transformDAPReportData({ _id, assigneesList, dateTotal })
      );
      showDAPReport(true);
    }
  }

  // console.log("report::", reports);

  // setReportData(reports);

  const downloadReport = () => {
    // console.log("Downloading Report");
    // const reportData = reports.map((report: any) => {
    //   report.dates = report.dates.map((date: any) => date.date);
    //   report.assignees = report.assignees.map((assignee: any) => assignee.name);
    //   report.projects = report.projects.name;
    //   report = { report, ...report.tasks };
    //   delete report.tasks;

    //   return report;
    // });
    // console.log("report", reportData);
    // console.log("reportList", reportList);
    function formatFilename() {
      const date = new Date();
      const year = date.getFullYear().toString().slice(-2);
      const month = date.toLocaleString("default", { month: "short" });
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const second = date.getSeconds();
      return `SCT-Report-${month}-${day}-${year}-${hours}:${minutes}:${second}.csv`;
    }
    convertJSONtoCSV(reportList, formatFilename());
  };

  return (
    <div className="tsk-lists-wrap remove-dtl-bottom-sec">
      <DownloadButton
        label="Download"
        handleClick={downloadReport}
        permission="tasks:write"
      />
      {PADReport ? <PADReportList reports={reports} /> : ""}
      {PDAReport ? <PDAReportList reports={reports} /> : ""}

      {APDReport ? <APDReportList reports={reports} /> : ""}
      {ADPReport ? <ADPReportList reports={reports} /> : ""}

      {DPAReport ? <DPAReportList reports={reports} /> : ""}
      {DAPReport ? <DAPReportList reports={reports} /> : ""}
    </div>
  );
};

const ReportGroupList = ({
  selectedProject,
  selectedAssignee,
  selectedDates,
  groupByOrders,
  myToast,
}: {
  selectedProject: string[];
  selectedAssignee: string[];
  selectedDates: Date | Date[];
  groupByOrders: string[];
  myToast: any;
}) => {
  const [PADReport, showPADReport] = useState(false);
  const [PDAReport, showPDAReport] = useState(false);

  const [APDReport, showAPDReport] = useState(false);
  const [ADPReport, showADPReport] = useState(false);

  const [DAPReport, showDAPReport] = useState(false);
  const [DPAReport, showDPAReport] = useState(false);

  let startDate = "";
  let endDate = "";
  if (selectedDates) {
    let date = selectedDates.toString().split(",");
    startDate = dateBeautify(date[0]);
    endDate = dateBeautify(date[1]);
  }

  const { reportList, isReportLoading } = useReportList(
    selectedProject?.join(","),
    selectedAssignee?.join(","),
    startDate,
    endDate,
    groupByOrders
  );

  const { reportListTotal } = useReportListTotal(
    selectedProject?.join(","),
    selectedAssignee?.join(","),
    startDate,
    endDate
  );

  if (isReportLoading) return <DataLoading />;

  return (
    <div className="task-top-table-separate">
      {reportListTotal ? (
        <ReportsHeader
          title={"Task Report"}
          total={reportListTotal}
          myToast={myToast}
          selectViewOptions=""
        />
      ) : (
        ""
      )}
      {!isReportLoading &&
      reportList.length > 0 &&
      groupByOrders.length === 3 ? (
        <ReportsTaskList
          reportList={reportList}
          group={groupByOrders}
          showPADReport={showPADReport}
          PADReport={PADReport}
          PDAReport={PDAReport}
          showPDAReport={showPDAReport}
          APDReport={APDReport}
          showAPDReport={showAPDReport}
          ADPReport={ADPReport}
          showADPReport={showADPReport}
          DAPReport={DAPReport}
          showDAPReport={showDAPReport}
          DPAReport={DPAReport}
          showDPAReport={showDPAReport}
        />
      ) : (
        <DataEmpty
          headerText={"Look like there’s currently nothing to see here"}
          contentText={"No results were found. Request to add task."}
        />
      )}
    </div>
  );
};

const ProjectReportList = ({
  selectProject,
  selectedRange,
  selectedDates,
  selectViewOptions,
  myToast,
}: {
  myToast: any;
  selectProject: string | undefined;
  selectedRange: string | undefined;
  selectedDates: Date | Date[] | undefined;
  selectViewOptions: string;
}) => {
  let startDate = "";
  let endDate = "";
  if (selectedDates) {
    let date = selectedDates.toString().split(",");
    startDate = dateBeautify(date[0]);
    endDate = dateBeautify(date[1]);
  }

  const { projectReportList, isProjectReportLoading } = useProjectReportList(
    selectProject,
    selectedRange,
    startDate,
    endDate
  );

  const { reportListTotal } = useProjectReportListTotal(
    selectProject,
    startDate,
    endDate
  );

  if (projectReportList) {
    projectReportList.datasets = projectReportList.datasets?.map(
      (item: any) => {
        item.backgroundColor = randomColor({
          luminosity: "light",
          format: "rgb",
        });
        return item;
      }
    );
  }

  if (isProjectReportLoading) {
    return <DataLoading />;
  }

  return (
    <div className="task-top-table-separate">
      <ReportsHeader
        title={"Project Report"}
        total={reportListTotal}
        myToast={myToast}
        selectViewOptions=""
      />
      {selectViewOptions && selectViewOptions === "chart" ? (
        <div className="main-data-block">
          <section className="main-section report-main-block">
            <div className="d-flex count-manage-ui count-manage-main-screen working-duration">
              <Bar datasetIdKey="id" data={projectReportList} />
            </div>
          </section>
        </div>
      ) : (
        <>Table view</>
      )}
    </div>
  );
};



type optionItems = { label: string; value: string }[];

function Report() {
  const [selectedProject, setSelectedProject] = useState<string[]>();
  const [selectedAssignee, setSelectAssignee] = useState<string[]>();
  const [selectedDates, setSelectDates] = useState<Date | Date[] | undefined>();
  const [groupByOrders, setGroupByOrders] = useState<string[] | undefined>();
  const [showReports, setShow] = useState(false);
  const [showLeaves, setLeaveShow] = useState(false);
  const [selectedTeam, setSelectTeam] = useState<string | undefined>();
  const [selectedEmployee, setSelectEmployee] = useState<string | undefined>();
  const [reportType, setReportType] = useState("task");

  const [selectedRange, setSelectRange] = useState<string | undefined>();
  const [selectProject, setSelectProject] = useState<string | undefined>();
  const [selectViewOptions, setSelectViewOptions] = useState<string>("chart");
  const [selectOption,setSelectOption]=useState<string>("table")
  const [showProject, setProjectsShow] = useState(false);
  const [teamId, setTeamId] = useState<any>("");
  const [generateReport, setGenerateReport] = useState(false); // State to control report generation

  const { projectList } = useProjectList();
  const { assigneesList } = useAssigneesList(selectedProject?.join(","));
  const { teamList } = useTeamsList();
  const { employeeList } = useEmployeeList(teamId);
  const groupOptions: optionItems = [
    { label: "Date", value: "date" },
    { label: "Project", value: "project" },
    { label: "Assignees", value: "assignees" },
  ];

  const [selectedGroup, setSelectedGroup] = useState<optionItems>(groupOptions);

  const myToast = useRef(null);

  useEffect(() => {
    setSelectedGroup(selectedGroup);
    if (selectedGroup) {
      let orderby = selectedGroup.map((item) => {
        return item.value;
      });
      setGroupByOrders(orderby);
    }
  }, [selectedGroup]);

  return (
    <>
      <Toast ref={myToast} />
      <ReportSidePanel
        projectList={projectList}
        assigneesList={assigneesList}
        teamList={teamList}
        employeeList={employeeList}
        setProjectsShow={setProjectsShow}
        selectedProject={selectedProject}
        selectedAssignee={selectedAssignee}
        selectedDates={selectedDates}
        myToast={myToast}
        setSelectedProject={setSelectedProject}
        setSelectAssignee={setSelectAssignee}
        setSelectDates={setSelectDates}
        setShow={setShow}
        setSelectedGroup={setSelectedGroup}
        selectedGroup={selectedGroup}
        groupOptions={groupOptions}
        reportType={reportType}
        setReportType={setReportType}
        selectedRange={selectedRange}
        setSelectRange={setSelectRange}
        selectProject={selectProject}
        setSelectProject={setSelectProject}
        selectedTeam={selectedTeam}
        selectedEmployee={selectedEmployee}
        setSelectTeam={setSelectTeam}
        setSelectEmployee={setSelectEmployee}
        setTeamId={setTeamId}
        setGenerateReport={setGenerateReport}
        setLeaveShow={setLeaveShow}
        setSelectViewOptions={setSelectViewOptions}
        selectViewOptions={selectViewOptions}
        setSelectOption={setSelectOption}
        selectOption={selectOption}
      />
      {showReports &&
      selectedProject &&
      selectedAssignee &&
      selectedDates &&
      groupByOrders &&
      reportType === "task" ? (
        <ReportGroupList
          selectedProject={selectedProject}
          selectedAssignee={selectedAssignee}
          selectedDates={selectedDates}
          groupByOrders={groupByOrders}
          myToast={myToast}
        />
      ) : (
        ""
      )}
      {showProject &&
      selectProject &&
      selectedRange &&
      selectedDates &&
      selectViewOptions &&
      reportType === "project" ? (
        <ProjectReportList
          selectProject={selectProject}
          selectedRange={selectedRange}
          selectedDates={selectedDates}
          selectViewOptions={selectViewOptions}
          myToast={myToast}
        />
      ) : (
        ""
      )}

      {showLeaves &&
      selectedTeam &&
      selectedEmployee &&
      selectedRange &&
      selectedDates &&
      selectViewOptions &&
      generateReport &&
      reportType === "leave" ? (
        <LeaveReportList
          selectedTeam={selectedTeam}
          selectedEmployee={selectedEmployee}
          selectedDates={selectedDates}
          selectedRange={selectedRange}
          selectViewOptions={selectViewOptions}
          myToast={myToast}
        />
      ) : (
        ""
      )}


     {showLeaves &&
      selectedTeam &&
      selectedEmployee &&
      selectedRange &&
      selectedDates &&
      selectViewOptions &&
      generateReport &&
      reportType === "summary" ? (
        <LeaveSummaryReportList
          selectedTeam={selectedTeam}
          selectedEmployee={selectedEmployee}
          selectedDates={selectedDates}
          selectedRange={selectedRange}
          selectViewOptions={selectOption}
          myToast={myToast}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Report;

